module.exports = __webpack_public_path__ + "static/img/6.e316e3bb.jpg";